wbApp.filter('groups', ['$translate', 'groupSvc',
    function ($translate, groupSvc) {

        var models = groupSvc.getAllAsync();

        function asyncResult(input) {
            if (models.$resolved) {
                var selected = _.flatten(_.map(input, function (item) {
                    return _.filter(models, { groupID: item });
                }));

                if (selected.length > 0) {
                    return _.map(selected, 'name').join(', ')
                } else {
                    return '';
                }
            } else {
                return $translate.instant('TXT_LOADING_DATA');
            }
        }

        asyncResult.$stateful = true;

        return asyncResult;
    }]
);